<template>
  <div class="lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="AddHubConnectWifi-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="AddHubConnectWifi-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <WrapperSvgTitleText>
        <template v-slot:svg>
          <svg viewBox="0 0 113.39 113.39">
            <g transform="translate(175.085 -251.936)">
              <path class="AddHubConnectWifi-st0" d="M-154.46,251.94h71.77c11.39,0,20.63,9.26,20.63,20.69v72c0,11.43-9.23,20.69-20.63,20.69h-71.77c-11.39,0-20.63-9.26-20.63-20.69v-72C-175.09,261.2-165.85,251.94-154.46,251.94z"/>
              <path class="AddHubConnectWifi-st1" d="M-77.8,353.99c0,0-15.63,2.86-40.78,2.86s-40.78-2.86-40.78-2.86c-2.45,0-4.43-1.99-4.43-4.45c0,0-2.85-15.68-2.85-40.91s2.85-40.91,2.85-40.91c0-2.46,1.99-4.45,4.43-4.45l0,0c0,0,15.63-2.86,40.78-2.86s40.78,2.86,40.78,2.86c2.45,0,4.43,1.99,4.43,4.45l0,0c0,0,2.85,15.68,2.85,40.91s-2.85,40.91-2.85,40.91C-73.36,352-75.35,353.99-77.8,353.99C-77.8,353.99-77.8,353.99-77.8,353.99z"/>
            </g>
            <g transform="translate(75.959 81.746)">
              <path class="AddHubConnectWifi-st2" d="M1.27-33.95c-5.52-5.63-13.07-8.79-20.93-8.76c-7.88-0.05-15.43,3.11-20.93,8.76c-0.64,0.61-0.66,1.62-0.06,2.26c0.02,0.02,0.04,0.04,0.06,0.06l2.31,2.31c0.61,0.64,1.62,0.66,2.25,0.06c0.02-0.02,0.04-0.04,0.06-0.06c9.01-9.04,23.62-9.04,32.64,0c0.61,0.64,1.62,0.66,2.25,0.06c0.02-0.02,0.04-0.04,0.06-0.06l2.31-2.32c0.33-0.29,0.51-0.72,0.49-1.16C1.81-33.24,1.62-33.68,1.27-33.95z"/>
              <path class="AddHubConnectWifi-st2" d="M-19.67-29.49c-4.33-0.03-8.5,1.7-11.54,4.8c-0.64,0.61-0.66,1.62-0.06,2.26c0.02,0.02,0.04,0.04,0.06,0.06l2.31,2.32c0.61,0.64,1.62,0.66,2.25,0.06c0.02-0.02,0.04-0.04,0.06-0.06c1.84-1.82,4.33-2.84,6.92-2.81c2.57,0.05,5.04,1.05,6.93,2.81c0.61,0.64,1.62,0.66,2.25,0.06c0.02-0.02,0.04-0.04,0.06-0.06l2.31-2.32c0.64-0.61,0.66-1.62,0.06-2.26c-0.02-0.02-0.04-0.04-0.06-0.06C-11.17-27.79-15.33-29.52-19.67-29.49z"/>
              <ellipse class="AddHubConnectWifi-st2" cx="-19.67" cy="-12.95" rx="3.3" ry="3.31"/>
            </g>
          </svg>
        </template>
        <template v-slot:title>
          {{$store.getters.language.texts.AddHubConnectWifi_title}}
        </template>
        <template v-slot:text>
          {{$store.getters.language.texts.AddHubConnectWifi_text}}
        </template>
      </WrapperSvgTitleText>
    </div>
    <div class="AddHubConnectWifi-wrapper-wifi lxn-margin-auto lxn-border-round">
      <div class="AddHubConnectWifi-wifi lxn-text-center lxn-title lxn-text-en">
        WiFi:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{hubWiFiAddress}}
      </div>
      <div class="AddHubConnectWifi-wifi lxn-text-center lxn-title lxn-text-en">
        Password:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{$store.state.defaultWifiPassword}}
      </div>
    </div>
    <div class="AddHubConnectWifi-button lxn-margin-auto lxn-w100">
      <CustomButton @click="next" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.AddHubConnectWifi_button}}
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import WrapperSvgTitleText from '@/components/addNewDevice/WrapperSvgTitleText.vue'
import CustomButton from '@/components/CustomButton.vue'
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import * as CONFIGS from '@/statics/configs.js'
import Logger from '@/statics/logger.js'
import Messaging from '@/statics/messaging.js'

var messaging = new Messaging(new Logger(false));

export default {
  name: 'AddHubConnectWifi',
  components: {
    CustomCurve,
    TopNav,
    WrapperSvgTitleText,
    CustomButton
  },
  computed: {
    hubWiFiAddress: function() {
      return this.$store.state.defaultWifiPrefix + messaging.utility.uuidToHexString(this.$store.state.scannedQR.uuid).toUpperCase();
    }
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    next: function () {
      var psk = this.$store.state.scannedQR.fallback;
      var password = this.$store.state.tempHub.password;
      var name = this.$store.state.tempHub.name;
      var color = this.$store.state.tempHub.color;
      var destinationUUID = this.$store.state.scannedQR.uuid;
      var sourceUUID = this.$store.state.user.uuid;

      if(!psk || !password || !name || (!color && color != 0)){
        this.$store.commit('setScannedQR', null);
        this.$store.commit('SetTempHubPassword', null);
        this.$store.commit('SetTempHubNameColor', {name: null, color: null});
        this.$router.push('/');
      }else{
        this.$store.commit('setAppBusy', true);
        var messagingHook = new Messaging(new Logger(false));
        messagingHook.init({
          psk: psk,
          destinationUUID: destinationUUID,
          sourceUUID: sourceUUID
        });
        var newPSK = messaging.utility.generateRandomPSK();
        this.$store.dispatch('takeOverHub', {connectionType: 'Local',messagingHook: messagingHook,hubUUID: destinationUUID,psk: newPSK, password: password})
        .then( () => {
          this.$store.commit('addHub', {
            name: name,
            color: color,
            psk: newPSK,
            uuid: destinationUUID,
            ipAddress: null,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
            stateUpdateEnabled: false,
            stateUpdatePending: false,
            isOwner: true,
            firmWareYear: null,
            firmWareMonth: null,
            isMQTTTConnected: null,
            wifiType: null,
            ssid: null,
            dateStamp: null,
            timeStamp: null,
            networkAddress: null,
            staticIp: false,
            port: 80,
            users: [
              {
                uuid: this.$store.state.user.uuid,
                name: this.$store.getters.language.texts.Hub_Owner,
                mobile: this.$store.state.user.mobileNumber,
                isOwner: true,
              },
            ]
          });
          this.$store.commit('setScannedQR', null);
          this.$store.commit('SetTempHubPassword', null);
          this.$store.commit('SetTempHubNameColor', {name: null, color: null});
          this.$store.commit('saveState');
          this.$store.dispatch('updateHubNodeStatus', destinationUUID);
          this.$router.push('/AddHub-Success');
          this.$store.commit('setAppBusy', false);
        }).catch(response => {
          console.log("addhubconnectwifi next method",response)
          if(response.rejectCode == 1){
            this.$store.commit('SetTempHubPassword', null);
            this.$store.commit('SetTempHubNameColor', {name: null, color: null});
            this.$router.push('/AddHub-LedError');
          }else if(response.rejectCode == 2){
            this.$router.push('/AddHub-NotFound');
          }else if(response.rejectCode == 3){
            this.$router.push('/AddHub-NotFound');
          }
          this.$store.commit('setAppBusy', false);
        });
      }
    }
  }
}
</script>

<style>
  .AddHubConnectWifi-topCurve-wrapper {
    height: 200px;
  }
  .AddHubConnectWifi-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 1;
    background-color: #ffffff;
  }
  .AddHubConnectWifi-wrapper-wifi {
    width: calc(100% - 36px);
    height: 70px;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding-top: 5px;
    padding-bottom: 5px;
    color: #53636C;
  }
  .AddHubConnectWifi-wifi {
    height: 30px;
    line-height: 30px;
  }
  .AddHubConnectWifi-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
	.AddHubConnectWifi-st0 {
    fill: #ECECEC;
  }
	.AddHubConnectWifi-st1 {
    fill: #53636C;
  }
	.AddHubConnectWifi-st2 {
    fill: #1EA5DE;
  }
</style>
